export default "__VITE_ASSET__CsguNAfA__"